module.exports = __webpack_public_path__ + "media/img/vca/facebook-9443d899ee1516584c2eee5161b88546.png";